<div #container class="monaco-editor-container"></div>
